export function convertMinutesToHours(minutesInput: number) {
  if (typeof minutesInput !== "number") return undefined;
  const minutes = Math.floor(minutesInput);

  if (minutes < 60) {
    return `${minutes} min`;
  }

  if (minutes % 60 === 0) {
    return `${minutes / 60} h`;
  }

  return `${Math.floor(minutes / 60)}h ${minutes % 60}min`;
}

export function convertMetersToKm(metersInput: number) {
  if (typeof metersInput !== "number") return undefined;
  const meters = Math.floor(metersInput);

  return `${Math.round((meters / 1000) * 10) / 10} km`;
}

enum ByteDisplay {
  Bytes = 0,
  KB = 1,
  MB = 2,
  GB = 3,
  TB = 4,
}

export function bytesToSize(
  bytes: number,
  size: keyof typeof ByteDisplay = "MB",
  decimals = 2
) {
  if (bytes == 0) return `${bytes}${size}`;
  const i = ByteDisplay[size];
  const multiplier = Math.pow(10, decimals);
  const decimal =
    Math.ceil((bytes / Math.pow(1024, i)) * multiplier) / multiplier;
  return `${decimal}${size}`;
}

export function bytesToSizeAuto(bytes: number, decimals = 0) {
  if (!+bytes) return "0 Bytes";

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
}
